import { defineStore } from 'pinia';
import { WorkHistoryPrimary } from '@/types/pages/WorkHistory';
import { OccupationPrimary } from '@/types/models/occupation';

const initialState: WorkHistoryPrimary = {
  id: undefined,
  income_id: undefined,
  experienced_companies_number: undefined,
  corporation_name: '',
  years_of_service: undefined,
  from_year: undefined,
  from_month: undefined,
  to_year: undefined,
  to_month: undefined,
  is_enrolled: true,
  employment_type_id: undefined,
  resume_blocked_companies: [],
  candidate_resume_occupations: [],
  candidate_resume_experience: [],
  candidate_resume_work_histories: [],
  experienced_companies_remarks: '',
};

export const useWorkHistoryStore = defineStore('workHistory.store', {
  state: (): WorkHistoryPrimary => ({ ...initialState }),
  actions: {
    createOccupations(occupations: OccupationPrimary[]) {
      this.candidate_resume_occupations = occupations.map(occupation => {
        const candidateResumeOccupation = this.candidate_resume_occupations.find(
          item => item.occupation_id === occupation.id
        );
        return {
          parent_name: occupation.parentName,
          occupation_id: occupation.id,
          name: occupation.name,
          years_of_experience: candidateResumeOccupation?.years_of_experience || 0,
        };
      });
    },

    deleteOccupations(occupationId: number) {
      this.candidate_resume_occupations = this.candidate_resume_occupations.filter(
        occupation => occupation.occupation_id != occupationId
      );
    },

    updateYearsOfExperience(occupationId: number, year: any) {
      const objectIndex = this.candidate_resume_occupations.findIndex(
        occupation => occupation.occupation_id == occupationId
      );
      this.candidate_resume_occupations[objectIndex].years_of_experience = year;
    },
  },
});
